/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {Vue} from 'vue-property-decorator';
import {MutationTree} from 'vuex';
import {
    AchievementClaimResponseInterface,
    ActiveCommunityChallengeStateInterface,
    ActiveCommunityChallengeStateResponseInterface, CommunityChallengeAchievementInterface,
} from '@/store/modules/community-challenge/types';

/**
 * Game state mutations.
 * @author Mark Thompson <mthompson@frontier.co.uk>
 */

export const mutations: MutationTree<ActiveCommunityChallengeStateInterface> = {
    /**
     * @param {ActiveCommunityChallengeStateInterface} state
     * @param {ActiveCommunityChallengeStateResponseInterface} data
     */
    setActiveChallenge(
        state: ActiveCommunityChallengeStateInterface,
        data: ActiveCommunityChallengeStateResponseInterface,
    ): void {
        Vue.set(state, 'challenge', data.challenge);
        Vue.set(state, 'count', data.count || 0);
        Vue.set(state, 'milestones', data.milestones || []);
        Vue.set(state, 'achievements', data.achievements || []);
        Vue.set(state, 'claimable', data.claimable || []);
    },

    /**
     * @param {ActiveCommunityChallengeStateInterface} state
     * @param {AchievementClaimResponseInterface} claimResponse
     */
    updateFromClaim(
        state: ActiveCommunityChallengeStateInterface,
        claimResponse: AchievementClaimResponseInterface,
    ): void {
        const cIndex: number =
            state.claimable.findIndex(
                (item: CommunityChallengeAchievementInterface) => item['@id'] === claimResponse.achievement['@id']);

        if (cIndex >= 0) {
            Vue.set(state.claimable[cIndex], 'claimable', claimResponse.achievement.claimable);
            Vue.set(state.claimable[cIndex], 'claimedAtTimestamp', claimResponse.achievement.claimedAtTimestamp);
        }

        const aIndex: number = state.achievements.findIndex(
            (item: CommunityChallengeAchievementInterface) => item['@id'] === claimResponse.achievement['@id']);

        if (aIndex >= 0) {
            Vue.set(state.achievements[aIndex], 'claimable', claimResponse.achievement.claimable);
            Vue.set(state.achievements[aIndex], 'claimedAtTimestamp', claimResponse.achievement.claimedAtTimestamp);
        }
    },

};
